import React from 'react'
import InputTextField from './InputTextField'

const InputMail = ({
  error,
  ...others
}) => {
  return (
    <InputTextField
      label="Mail"
      error={error}
      helperText={
        (error)
          ? "Cette adresse mail est invalide"
          : null
      }
      {...others}
    />
  )
}

export default InputMail
